export const columns = ['icon', 'name', 'email', 'phoneNumber', 'remarks'];
